import React from 'react';
import { Construction, ArrowLeft } from 'lucide-react';

interface ComingSoonProps {
  title: string;
  description?: string;
  features?: string[];
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ 
  title, 
  description, 
  features 
}) => {
  return (
    <div className="text-center py-12">
      <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-primary-100 mb-4">
        <Construction className="h-6 w-6 text-primary-600" />
      </div>
      
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">
        {title}
      </h1>
      
      <p className="text-gray-600 mb-8 max-w-md mx-auto">
        {description || "This section is currently under development. We're working hard to bring you this feature."}
      </p>

      {features && features.length > 0 && (
        <div className="max-w-md mx-auto mb-8">
          <h3 className="text-sm font-medium text-gray-900 mb-3">Coming Soon:</h3>
          <ul className="text-sm text-gray-600 space-y-1">
            {features.map((feature, index) => (
              <li key={index} className="flex items-center justify-center">
                <span className="mr-2">•</span>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      )}

      <button
        onClick={() => window.history.back()}
        className="btn btn-primary flex items-center space-x-2 mx-auto"
      >
        <ArrowLeft className="h-4 w-4" />
        <span>Go Back</span>
      </button>
    </div>
  );
};